<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
  <circle cx="12" cy="12" r="9"></circle>
  <path d="M12 11 V16.5"></path>
  <circle cx="12" cy="7.8" r="0.4" fill="currentColor"></circle>
</svg>